import { IconDefaultType as IconType } from "@slhuiicon/icon";

const CLOSE_ICON_TYPE = IconType.ICO_CLOSE;
const ALERT_ICON_TYPE = IconType.ICO_MISSINGINFO;
const EVENT_CONTENT_NOTIFICATION_CLOSED = "content-notification-closed";

export { CLOSE_ICON_TYPE, ALERT_ICON_TYPE, EVENT_CONTENT_NOTIFICATION_CLOSED };
